"use client";
import e, { useState as _, useMemo as c, useCallback as h, useEffect as P } from "react";
import "./index.es9.js";
import "./index.es10.js";
import "./index.es11.js";
import "./index.es12.js";
import "./index.es13.js";
import "./index.es14.js";
import "./index.es15.js";
import "./index.es16.js";
import Q from "./index.es17.js";
import "./index.es27.js";
import "./index.es28.js";
import T from "./index.es19.js";
import "./index.es20.js";
import "./index.es21.js";
import j from "./index.es22.js";
import "./index.es23.js";
import "./index.es24.js";
import "./index.es25.js";
import "./index.es26.js";
import "./index.es29.js";
import "./index.es30.js";
import J from "./index.es31.js";
import "./index.es32.js";
import { useQuery as w } from "@tanstack/react-query";
import { flattenIndicatorGroups as S, regionCodesFromRegionSelection as W, createFetchDistribution as X, createFetchMonitorApiIndicatorDetails as Y, createFetchAllMonitorApiIndicatorValues as Z, createComponentsLinks as G } from "./index.es4.js";
import U from "./index.es34.js";
import ee from "./index.es35.js";
import te from "./index.es36.js";
import ne from "./index.es37.js";
const x = (o, i) => o && o.length && i && o.find((s) => s.slug === i) || null, oe = (o) => {
  const { __component: i, componentsLinks: s } = o;
  if (i === "common.accordions-block") {
    const m = o.accordions.map((n) => ({
      ...n,
      htmlId: s.find(
        (r) => r.componentType === "accordion" && r.componentId === n.id && r.display === n.title
      )?.hash
    }));
    return /* @__PURE__ */ e.createElement("div", { className: "bl-m-b-7" }, /* @__PURE__ */ e.createElement(J, { ...o, accordions: m }));
  }
  if (i === "common.text-block") {
    const m = s.find(
      (n) => n.componentType === "text" && n.componentId === o.id
    )?.hash;
    return /* @__PURE__ */ e.createElement("div", { className: "bl-m-b-7" }, /* @__PURE__ */ e.createElement(
      Q,
      {
        ...o,
        type: o.isInfoBlock ? "infobox" : "normal",
        htmlId: m
      }
    ));
  }
  return /* @__PURE__ */ e.createElement(e.Fragment, null);
}, ie = "bufdir:hash:navigate", Ae = ({
  title: o,
  regionsData: i,
  shortDescription: s,
  monitorType: m,
  indicatorGroups: n,
  monitorApiUrl: r,
  slug: g,
  groupSlug: d,
  distributionExplanation: V,
  components: b,
  hash: q
}) => {
  const [p, L] = _(
    null
  ), a = c(
    () => p?.regionSelection,
    [p]
  ), I = c(
    () => S(n),
    [n]
  ), N = c(
    () => I.map((t) => t.indicatorApiId),
    [I]
  ), u = c(
    () => p?.categories || [],
    [p]
  ), C = c(
    () => a ? W(a) : [],
    [a]
  ), f = c(
    () => ({ indicatorIds: N, regionCodes: C }),
    [N, C]
  ), $ = h(
    X(r),
    [r]
  ), A = h(
    Y(r),
    [r]
  ), H = h(
    Z(r, m),
    [r, m]
  ), { data: k } = w({
    queryKey: ["monitoroverview", f],
    queryFn: () => H(f)
  }), v = c(() => k?.filter(
    (t) => t.categories.length === u.length && t.categories.every((y) => u.includes(y))
  ) || [], [k, u]), { data: E } = w({
    queryKey: ["monitordetails", f],
    queryFn: () => A(f)
  }), M = c(() => E ? E.map((t) => ({ ...t, region: i.byCode[t.regionCode] })) : [], [E, i]), [l, K] = _(
    x(n, d || "")
  ), F = c(
    () => p?.compareScope || "County",
    [p]
  );
  P(() => {
    K(x(n, d || ""));
  }, [n, d]);
  const O = h(
    (t) => {
      L(t);
    },
    [m, i, g, d]
  ), z = l ? l.title : o, B = l ? l.description : s, R = G(b || []), D = (t) => {
    const y = new CustomEvent(ie, {
      detail: t.hash
    });
    document.dispatchEvent(y);
  };
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(j, null, z), s && /* @__PURE__ */ e.createElement("div", { className: "bl-container bl-container--small bl-m-b-7" }, B), /* @__PURE__ */ e.createElement(
    ne,
    {
      componentsLinks: R,
      onNavigate: D
    }
  ), /* @__PURE__ */ e.createElement("div", { className: "bl-bg-sand-5" }, /* @__PURE__ */ e.createElement("div", { className: "bl-container bl-container--medium" }, /* @__PURE__ */ e.createElement("div", { className: "bl-p-y-5" }, /* @__PURE__ */ e.createElement(
    ee,
    {
      monitorType: m,
      regionsData: i,
      onChange: O,
      groupSlug: d
    }
  )))), /* @__PURE__ */ e.createElement("div", { className: "bl-container bl-container--medium" }, /* @__PURE__ */ e.createElement("div", { className: "bl-m-y-6" }, !!v?.length && !l && a?.primaryRegion && /* @__PURE__ */ e.createElement(
    te,
    {
      compareScope: F,
      regionsData: i,
      primaryRegion: a.primaryRegion,
      comparisonRegions: a.otherRegions,
      indicatorGroups: n,
      indicatorValues: v,
      details: M,
      categories: u,
      slug: g
    }
  ), !v?.length && !l && a?.primaryRegion && /* @__PURE__ */ e.createElement(T, null), l && a && d && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    U,
    {
      compareScope: F,
      fetchDistribution: $,
      regionsData: i,
      details: M,
      regionSelection: a,
      indicators: l.indicators,
      distributionExplanation: V,
      hash: q
    }
  )))), /* @__PURE__ */ e.createElement("div", { className: "bl-container bl-container--medium" }, !!b && b.map((t) => /* @__PURE__ */ e.createElement(
    oe,
    {
      componentsLinks: R,
      key: `component-${t.__component}-${t.id}`,
      ...t,
      keyContext: `component-${t.__component}-${t.id}`
    }
  ))));
};
export {
  Ae as default
};
//# sourceMappingURL=index.es3.js.map
